module.exports = __webpack_public_path__ + "static/media/contentmap.9e7ff061.png";